import GiftCardHeader from '@/components/giftCard/GiftCardHeader';
import HowItWorks from '@/components/giftCard/HowItWorks';
import LifetimeHero from '@/components/giftCard/LifetimeHero';
import Premium from '@/components/giftCard/Premium';
import { CardSection } from '@/components/giftCard/styles';
import FullscreenBackground from '@/components/image/FullscreenBackground';
import StripeElementsProvider from '@/components/purchase/StripeElementsProvider';
import { usePurchaseParamsState } from '@/hooks/store';

const LifetimeGiftCardLayout = () => {
	const { giftPrice } = usePurchaseParamsState();

	return (
		<StripeElementsProvider isStripeNext amount={giftPrice?.price ?? 6999} currency="usd">
			<GiftCardHeader isRedeem={false} />
			<LifetimeHero />
			<HowItWorks />
			<CardSection>
				<FullscreenBackground src="/_n/images/gift-card/module-gift-card-lifetime.webp" />
			</CardSection>
			<Premium />
		</StripeElementsProvider>
	);
};

export default LifetimeGiftCardLayout;
